import { Moment } from 'moment';

import { isMinLengthArray } from 'src/lib/isMinLengthArray';

import { TimeSeriesData } from '../helpers/dataTypes';

import { BarChartProps } from './BarChart';

export interface SingleSeriesData extends TimeSeriesData {
  value: number;
}

export interface StackCount {
  label?: string;
  value: number;
}

export interface MultiseriesData extends TimeSeriesData {
  stackCounts: StackCount[];
}

export const getSingleSeriesValue = (data: SingleSeriesData) => ({
  value: data.value,
  timestamp: data.timestamp,
  tooltipContent: `${data.value} passed`,
});

export const getMultiSeriesValue = (data: MultiseriesData) => ({
  value: data.stackCounts.reduce((total, stack) => stack.value + total, 0),
  timestamp: data.timestamp,
  tooltipContent: data.stackCounts
    .map((s) => `${s.value} ${s.label}`)
    .join(' | '),
  stackCounts: data.stackCounts,
});

export const generateSingleSeriesData = (
  startTime: Moment,
  numberOfRecords: number,
  resolutionInMinutes: number = 5, // Default resolution to 5 minutes
): BarChartProps<SingleSeriesData>['data'] => {
  let currentTime = startTime;

  const data = [];

  for (let i = 0; i < numberOfRecords; i++) {
    currentTime = currentTime.add(resolutionInMinutes, 'minutes');
    data.push({
      timestamp: currentTime.toISOString(),
      value: Math.floor(Math.random() * 20),
    });
  }

  if (!isMinLengthArray(1, data)) {
    throw new Error('no data');
  }
  return data;
};

export const generateMultiSeriesData = (
  startTime: Moment,
  numberOfRecords: number,
  seriesLabels: string[],
  resolutionInMinutes: number = 5, // Default resolution to 5 minutes
): BarChartProps<MultiseriesData>['data'] => {
  let currentTime = startTime;

  const data: MultiseriesData[] = [];

  for (let i = 0; i < numberOfRecords; i++) {
    currentTime = currentTime.add(resolutionInMinutes, 'minutes');
    const stackCounts = seriesLabels.map((seriesLabel) => ({
      label: seriesLabel,
      value: Math.floor(Math.random() * 20),
    }));
    data.push({
      timestamp: currentTime.toISOString(),
      stackCounts,
    });
  }

  if (!isMinLengthArray(1, data)) {
    throw new Error('no data');
  }
  return data;
};
